<template>
  <v-dialog
    v-model="open"
    :width="width"
    :fullscreen="$vuetify.display.smAndDown"
    :persistent="true"
    :scrollable="true"
  >
    <v-card>
      <v-toolbar :flat="true" :height="44" tile rounded="0" width="100%" :color="topColor">
        <slot name="title">
          <span class="card__title">
            {{ title }}
          </span>
        </slot>
        <v-spacer v-if="spacedTitle"></v-spacer>
        <div
            class="card__cancel"
            @click="closeDialog(false)"
        >
          <v-icon :size="$vuetify.display.width > 768 ? 25 : 20" class="font-weight-bold">clear</v-icon>
        </div>
      </v-toolbar>
      <v-card-text class="overflow-y-auto scrolled-style mt-7 mt-md-10 px-5 px-md-10 py-0" :style="{ height: contentHeight ? contentHeight: undefined }">
        <slot>

        </slot>
      </v-card-text>
      <v-card-actions class="pa-0 mt-5">
        <slot name="actions">
          <slot name="prepend-actions"></slot>
          <v-spacer v-if="left"></v-spacer>
          <v-btn
              class="apply__btn"
              v-if="applyable"
              :loading="loading"
              :readonly="loading"
              @click="closeDialog(true)"
          >
            <span class="apply__btn_text">
              {{ applyText }}
            </span>
          </v-btn>
          <v-spacer v-if="right"></v-spacer>
          <slot name="append-actions"></slot>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ScrollCenterDialog",
  props: {
    value: Boolean,
    title: String,
    scrolled: {
      default: true,
      type: Boolean
    },
    closed: {
      default: true,
      type: Boolean
    },
    spacedTitle: {
      default: true,
      type: Boolean,
    },
    left: {
      default: true,
      type: Boolean,
    },
    right: {
      default: true,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    applyable: {
      default: true,
      type: Boolean,
    },
    applyText: {
      default: 'Сохранить',
      type: String,
    },
    topColor: {
      default: 'white',
      type: String
    },
    width: {
      default: '600px',
      type: String,
    },
    contentHeight: {
      default: undefined,
      type: String
    }
  },
  data () {
    return {
      open: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  methods: {
    closeDialog (emit_apply = false) {
      if (emit_apply) {
        this.$emit('apply')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped lang="scss">
/*.scrolled-style::-webkit-scrollbar {*/
/*  width: 5px;*/
/*}*/

/*.scrolled-style::-webkit-scrollbar-track {*/
/*}*/

/*.scrolled-style::-webkit-scrollbar-thumb {*/
/*  background: gray;*/
/*  border-bottom-left-radius: 10px;*/
/*  border-top-left-radius: 10px;*/
/*}*/

.v-dialog--scrollable > .v-overlay__content > .v-card, .v-dialog--scrollable > .v-overlay__content > form > .v-card {
  border-bottom: 3px solid #376FFE;
  border-bottom: 5px solid #376FFE;
  box-shadow: 2px 2px 10px rgba(52, 52, 124, 0.25);
  border-radius: 10px !important;
}

.card__title {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  top: 0;
  height: 44px;
  justify-content: center;
  align-items: center;
  padding: 13px 20px;
  background-color: #376FFE;
  border-radius: 10px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-transform: lowercase;
  color: #FFFFFF;
}

.card__cancel {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  color: white;
  background-color: #376FFE;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: #376FFE;
    border: 2px solid #376FFE;
  }
}

.apply__btn {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 136px;
  height: 40px;
  border: 2px solid #3254B9;
  background: #3254B9;
  border-radius: 5px;

  &:hover {
    background-color: transparent;

    .apply__btn_text {
      color: #3254B9;
    }
  }
}

.apply__btn_text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 768px) {
  .card__title {
    font-size: 15px;
    line-height: 17px;
    height: 38px;
  }

  .card__cancel {
    width: 38px;
    height: 38px;
  }

  .apply__btn_text {
    font-size: 13px;
    line-height: 15px;
  }
}
</style>
